import { render, staticRenderFns } from "./mustStudy.vue?vue&type=template&id=4fead406&scoped=true"
import script from "./mustStudy.vue?vue&type=script&lang=js"
export * from "./mustStudy.vue?vue&type=script&lang=js"
import style0 from "./mustStudy.vue?vue&type=style&index=0&id=4fead406&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fead406",
  null
  
)

export default component.exports